// extracted by mini-css-extract-plugin
export var container = "_hv-0";
export var content = "_hv-3";
export var customerTitle = "_hv-4";
export var empty = "_hv-5";
export var gray = "_hv-6";
export var header = "_hv-7";
export var info = "_hv-8";
export var loading = "_hv-2";
export var loadingCard = "_hv-9";
export var oneLine = "_hv-a";
export var personName = "_hv-e";
export var pillContainer = "_hv-b";
export var selected = "_hv-1";
export var text = "_hv-c";
export var twoLines = "_hv-d";
export var unread = "_hv-f";
export var unreadIndicator = "_hv-g";